import Pagination from 'rc-pagination';
import _ from 'lodash';
import 'rc-pagination/assets/index.css';
import React, { useEffect, useState, useCallback } from 'react';
import { Row, Col, Button, Input } from 'reactstrap';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import moment from 'moment';
import { format, startOfDay } from 'date-fns';
import { useDispatch, useSelector } from 'react-redux';
import { getAllLogs } from '../../actions/BoxSessionLogging';
import { getSystemLogs } from '../../actions/SystemLogs';
import SetLimitEntries from '../../components/SetLimitEntries';
import Breadcrumbs from '../../components/Breadcrumb';
import ViewMore from '../../components/ViewMore';
import Calendar from '../../Res/Icon/Calendar.png';
import Company from '../../Res/Icon/Company.png';

import './systemLog.css';
import { ENG_LOCALE } from '../../lib/constants';
import NavLogBar from './Components/NavLogBar';
import SystemLogTable from './Components/SystemLogTable';
import OobLogTable from './Components/OobLogTable';
import utils from '../../lib/utils';

const sort = '-createdAt';

const ranges = {
  Today: [moment(), moment()],
  Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
  'Last 7 Days': [moment().subtract(6, 'days'), moment()],
  'Last 30 Days': [moment().subtract(29, 'days'), moment()],
  'This Month': [moment().startOf('month'), moment().endOf('month')],
  'Last Month': [
    moment()
      .subtract(1, 'month')
      .startOf('month'),
    moment()
      .subtract(1, 'month')
      .endOf('month'),
  ],
};

const SystemLog = () => {
  const token = localStorage.getItem('jwtToken') || null;
  const dispatch = useDispatch();

  const data = useSelector(state => state.AppState.boxDetails.systemLogs) || [];

  const [dateFrom, setDateFrom] = useState(moment().subtract(6, 'days')._d);
  const [dateTo, setDateTo] = useState(startOfDay(new Date()));
  const [optionSelect, onOptionSelect] = useState('user');
  const dateChange = (e, picker) => {
    setDateFrom(picker.startDate.toDate());
    setDateTo(picker.endDate.toDate());
  };

  const [userSearch, setUserSearch] = useState('');
  const [selected, setSelected] = useState('device');

  useEffect(() => {
    if (!!userSearch?.trim().length || (dateFrom && dateTo)) {
      debouncedDispatchQuery(1);
    }
    return debouncedDispatchQuery.cancel;
  }, [userSearch, dateFrom, dateTo]);

  const dispatchQuery = _.debounce((pageVal, limitVal) => {
    let searchBy = optionSelect === 'user' ? 'user' : 'serial';
    if (selected === 'system') searchBy = 'user';
    const { page, limit } = data;
    const pagination = { page: pageVal ? pageVal : page, limit: limitVal ? limitVal : limit, sort };
    const filters = { from: dateFrom, to: dateTo, [searchBy]: userSearch };
    if (selected === 'device') {
      dispatch(getAllLogs(token, pagination, filters));
    } else {
      dispatch(getSystemLogs(token, pagination, filters));
    }
  }, 300);
  const debouncedDispatchQuery = useCallback(dispatchQuery, [dateFrom, dateTo, userSearch]);

  const handleSearch = e => {
    setUserSearch(e.target.value);
  };
  const onTabChange = useCallback(async e => {
    setSelected(e);
    setDateFrom(moment().subtract(6, 'days')._d);
    setDateTo(startOfDay(new Date()));
    setUserSearch('');
    onOptionSelect('user');
  }, []);

  return (
    <>
      <div className="filter-section">
        <Row>
          {/* <Col md={6} sm={12}>
            <Breadcrumbs />
          </Col> */}
          {['device', 'system'].includes(selected) ? (
            <Col md={12} sm={12} className="d-flex justify-content-end">
              <Row className="justify-content-end row">
                <Col style={{ display: 'flex' }} md="2.5">
                  <div className="calls-page-select-cont">
                    <img style={{ height: '22px' }} src={Company} alt="..."></img>
                  </div>
                  <Input
                    type="select"
                    className="filter-append-dropdown"
                    onChange={e => onOptionSelect(e.target.value)}
                  >
                    <option value="user">User</option>
                    {selected === 'device' && (
                      <option value="serial">Serial number</option>
                    )}
                  </Input>
                </Col>
                <Col style={{ marginRight: '.5rem', display: 'flex' }} md="2.0">
                  <Input
                    name="user-search"
                    placeholder={`${optionSelect === 'user' ? 'Search User' : 'Serial number'}`}
                    value={userSearch}
                    onChange={e => handleSearch(e)}
                  />
                </Col>
                {dateFrom && dateTo && (
                  <Col md={3.5} style={{ marginRight: '1rem' }}>
                    <DateRangePicker
                      autoUpdateInput
                      startDate={dateFrom}
                      endDate={dateTo}
                      onApply={dateChange}
                      showCustomRangeLabel
                      alwaysShowCalendars
                      ranges={ranges}
                      opens="left"
                    >
                      <div className="input-group" style={{ alignItems: 'center' }}>
                        <span className="input-group-btn">
                          <Button
                            className="default date-range-toggle"
                            style={{
                              background: '#DDE6FA',
                              border: 'none',
                              color: '#FF2437',
                              width: '4rem',
                            }}
                          >
                            <img style={{ height: '22px' }} src={Calendar} alt="..."></img>
                          </Button>
                        </span>
                        <div className="view-data-input">
                          {format(dateFrom, 'MM/dd/yyyy')} - {format(dateTo, 'MM/dd/yyyy')}
                        </div>
                      </div>
                    </DateRangePicker>
                  </Col>
                )}
              </Row>
            </Col>
          ) : null}
        </Row>
      </div>

      <div className="viewContainer">
        <NavLogBar selected={selected} onTabChange={onTabChange} />
        {selected === 'device' ? (
          <>
            <div className="table-header-fixed">
              <table>
                <thead>
                  <tr>
                    <th className="cursor-pointer">Device Name</th>
                    <th className="cursor-pointer">Serial number</th>
                    <th className="cursor-pointer">Users</th>
                    <th className="cursor-pointer" style={{ width: '300px' }}>
                      Actions
                    </th>
                    <th className="cursor-pointer">Created At</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.docs?.map(element => {
                    return (
                      <tr>
                        <td>{element?.box?.displayName || '-'}</td>
                        <td>{element?.box?.serialNumber || '-'}</td>
                        <td>{element?.user?.name || '-'}</td>
                        <td className="action-description">
                          <ViewMore element={element} />
                        </td>
                        <td>
                          {utils.getDateTimeFormat(element?.createdAt, 'both')}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            {data && Object.keys(data).length ? (
              <Row className="justify-content-md-center">
                <SetLimitEntries
                  value={10}
                  onChange={limit => {
                    dispatchQuery(false, limit);
                  }}
                />

                <Pagination
                  locale={ENG_LOCALE}
                  className="pagination-container"
                  onChange={page => {
                    dispatchQuery(page, false);
                  }}
                  current={data.page}
                  total={data.totalDocs}
                  pageSize={data.limit}
                  showLessItems
                  showTitle={false}
                  showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                />
              </Row>
            ) : null}
          </>
        ) : selected === 'system'
          ? <SystemLogTable filters={{ from: dateFrom, to: dateTo, user: userSearch }}/>
            : selected === 'oob' && (<OobLogTable />)
        }
      </div>
    </>
  );
};

export default SystemLog;
